module.exports = __webpack_public_path__ + "img/2.0e5b5244.jpg";